import { render, staticRenderFns } from "./FormExpired.vue?vue&type=template&id=d8f6d9fc&"
import script from "./FormExpired.vue?vue&type=script&lang=ts&"
export * from "./FormExpired.vue?vue&type=script&lang=ts&"
import style0 from "./FormExpired.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports